import { cn } from "@/lib/utils";

interface SegmentedProps<T extends string> {
  label: string;
  value: T;
  options: { value: T; label: string }[];
  onChange: (value: T) => void;
}

/** Small segmented control: one choice among a few, all visible at once. */
export const Segmented = <T extends string>({
  label,
  value,
  options,
  onChange,
}: SegmentedProps<T>) => (
  <div
    role="group"
    aria-label={label}
    className="inline-flex w-fit overflow-hidden rounded-lg border border-border bg-background"
  >
    {options.map((option) => (
      <button
        key={option.value}
        type="button"
        aria-pressed={option.value === value}
        onClick={() => onChange(option.value)}
        className={cn(
          "px-2.5 py-1 text-[13px] transition-colors",
          option.value === value
            ? "bg-card font-medium text-foreground shadow-[inset_0_0_0_1px_var(--border)]"
            : "text-muted-foreground hover:text-foreground",
        )}
      >
        {option.label}
      </button>
    ))}
  </div>
);
